import EvidencePopup from './EvidencePopup';

export default EvidencePopup;
